import React, { Component, Fragment, useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  FormGroup,
  Row,
  Col,
  Table,
  InputGroup,
  InputGroupAddon,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  CustomInput,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  ButtonGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Label,
  Select,
} from "reactstrap";
import { connect } from "react-redux";

import { MDBDataTableV5 } from "mdbreact";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import classnames from "classnames";
import swal from "sweetalert";
import { getUserLocations } from "../../../store/Mini/actions";
import {
  getPurchaseIndentItems,
  getPuchaseIndentItemsSuccessful,
  PuchaseIndentItemsChecked,
  SetParams,
  RFQSelectedItems,
  addRFQRequest,
  AllPuchaseIndentItemsChecked,
  generateRFQasPDF,
  tooltipOpen,
  PIDetailsModel_open,
  addVendorsModelOpen,
  getMRItemImges,
  PIMRItemImagesModel_close,
  FiltersShowRightSidebar,
} from "../../../store/RequetForQuotation/actions";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import LoadingModel from "../../LoadingModel";
import "./NewRequestForQuotation.scss";
import GetMRPIDetails from "../../GetMRPIDetails";
import ItemDetails from "../../ItemDetails";
import AddVendorModel from "../AddVendorModel";
import MRItemImages from "../../MRItemImages";
import CancleItemModel from "../../cancelItemModel";

function PdfViewer({ url }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("📥 PdfViewer: fetching via proxy, url:", url);
    setLoading(true);
    setError(null);

    fetch(url)
      .then((res) => {
        console.log("📥 fetch response status:", res.status);
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.blob();
      })
      .then((blob) => {
        console.log("✅ Blob received, size:", blob.size);
        const objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ PdfViewer fetch error:", err);
        setError(err.message);
        setLoading(false);
      });

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [url]);

  if (loading) return <p style={{ padding: 10 }}>⏳ Loading PDF...</p>;
  if (error)
    return <p style={{ padding: 10, color: "red" }}>❌ Failed: {error}</p>;

  return (
    <iframe
      src={blobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}

class NewRequestForQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item_details: {},
      modal_Cancel: false,

      activeTab: 1,
      search: "",
      selectedOrderLocation: null,
      showImageModal: false,
    };
    this.PIItemModel = this.PIItemModel.bind(this);
    this.GetVendorslist = this.GetVendorslist.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.CreateRequestModel = this.CreateRequestModel.bind(this);
    this.handleValidRFQSubmit = this.handleValidRFQSubmit.bind(this);
    this.getAllCheckedRequest = this.getAllCheckedRequest.bind(this);
    this.requestingItems = this.requestingItems.bind(this);
    this.removeListItem = this.removeListItem.bind(this);
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  itemCancle_static(Item) {
    this.setState((prevState) => ({
      modal_Cancel: !prevState.modal_Cancel,
      item_details: Item,
    }));
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }
  PIItemModel(item) {
    this.setState((prevState) => ({
      PIItemModal_static: !prevState.PIItemModal_static,
      item_details: item,
    }));

    this.removeBodyCss();
  }
  componentDidMount() {
    this.props.getUserLocations();
    this.props.SetParams({
      ...this.props.params,
      page: 1,
      search: "",
    });
    this.props.getPurchaseIndentItems({
      ...this.props.params,
      page: 1,
      search: "",
    });
  }
  componentDidUpdate() {
    console.log(this.props.PIlistItems, "reeqqqq");
    console.log(this.props.RFQSelectItem, "this.props.RFQSelectItem.");
  }
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getPurchaseIndentItems({
        ...this.props.params,
        page: 1,
        search: e.target.value,
      });
    }
  };
  onSortChange = () => {
    var sort = ["purchaseindent", "date"];
    var picurrentSort = this.props.params.picurrentSort;
    var i = sort.indexOf(picurrentSort);
    if (i !== -1 && i + 1 < sort.length) {
      picurrentSort = sort[i + 1];
    } else {
      picurrentSort = sort[0];
    }
    this.props.SetParams({
      ...this.props.params,
      picurrentSort: picurrentSort,
    });
    this.props.getPurchaseIndentItems({
      ...this.props.params,
      picurrentSort: picurrentSort,
    });
  };
  onSortOrderChange = () => {
    var sortOrder = this.props.params.sortOrder;
    if (sortOrder === "") {
      sortOrder = "-";
    } else {
      sortOrder = "";
    }

    this.props.SetParams({ ...this.props.params, sortOrder: sortOrder });
    this.props.getPurchaseIndentItems({
      ...this.props.params,
      sortOrder: sortOrder,
    });
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getPurchaseIndentItems({
      ...this.props.params,
      page: pageNo,
    });
  }
  getAllCheckedRequest(e) {
    this.props.AllPuchaseIndentItemsChecked(e.target.checked);
  }
  getCheckedRequest(e, item, index) {
    this.props.PuchaseIndentItemsChecked(e.target.checked, item, index);
  }
  requestingItems() {
    this.props.PIlistItems.forEach((i) => {
      if (i.itemcheck === true) {
        this.props.RFQSelectedItems(true, i);
      }
    });
    if (this.props.PIlistItems.length === 0) {
      swal({ title: "Select Items", icon: "error" });
    }
    this.props.SetParams({
      ...this.props.params,
      page: 1,
      search: "",
    });
    this.props.getPurchaseIndentItems({
      ...this.props.params,
      page: 1,
      search: "",
    });
  }
  removeListItem(row) {
    this.props.RFQSelectedItems(false, row);
    this.props.SetParams({
      ...this.props.params,
      page: 1,
      search: "",
    });
    this.props.getPurchaseIndentItems({
      ...this.props.params,
      page: 1,
      search: "",
    });
  }
  GetVendorslist() {
    if (this.props.RFQSelectItem.length !== 0) {
      this.props.addVendorsModelOpen(this.props.match.params.id);
      // this.props.getVendorsList({}, false);
      this.toggleTab(1);
      this.removeBodyCss();
    } else {
      swal({ title: "Select Items", icon: "error" });
    }
  }

  CreateRequestModel() {
    if (this.props.RFQSelectItem.length !== 0) {
      if (this.props.RFQSelectVendors.length !== 0) {
        this.setState((prevState) => ({
          modal_static: !prevState.modal_static,
        }));
        this.toggleTab(1);
        this.removeBodyCss();
      } else {
        swal({ title: "Select Vendors", icon: "error" });
      }
    } else {
      swal({ title: "Select Items", icon: "error" });
    }
  }
  handleValidRFQSubmit() {
    var vendor_ids = this.props.RFQSelectVendors.map((vend) => {
      return vend.id;
    });
    var rfqitems = this.props.RFQSelectItem.map((item) => {
      var rfqipiis = item.rfqipiis.map((i) => {
        i.unit_id = i.unit.id;
        i.piitem_id = i.piitem.id;
        return i;
      });
      item.product_id = item.product.id;
      item.unit_id = item.unit.id;
      item.rfqipiis = rfqipiis;
      if (item?.orderlocation?.id) {
        item.orderlocation_id = item.orderlocation.id;
      }
      return item;
    });

    var location_id = this.props.userLocation[0].id;
    var RFQdata = {
      location_id: location_id,
      rfqitems: rfqitems,
      vendor_ids: vendor_ids,
    };

    this.props.addRFQRequest(RFQdata);
  }
  RFQModelClose() {
    if (this.props.downloadRFQButton === true) {
      this.props.history.push("/rfqdashboard");
    } else {
      this.setState({ modal_static: false });
    }
  }

  toggle = (item) => {
    this.props.tooltipOpen(item);
    // this.setState({
    //   tooltipOpen: !this.state.tooltipOpen,
    // });
  };

  // Apply filter
  applyDateFilter = () => {
    const { start_date, end_date } = this.state;

    this.props.getPurchaseIndentItems({
      ...this.props.params,
      start_date,
      end_date,
    });
  };

  clearDateFilter = () => {
    this.setState({ start_date: "", end_date: "" }, () => {
      this.props.SetParams({
        ...this.props.params,
        start_date: "",
        end_date: "",
      });
      this.props.getPurchaseIndentItems({ ...this.props.params });
    });
  };

  //---------------------------------------

  render() {
    var selitems = this.props.RFQSelectItem.map((row) => ({
      PINo: (
        <span
          className="font-size-12"
          style={{ textDecoration: "underline", color: "blue" }}
        >
          <Link
            to="#"
            onClick={() => {
              this.props.PIDetailsModel_open(row.PI_Id);
            }}
            className="text-primary mr-1"
          >
            <b>{row.PI_Code}</b>
          </Link>
          {/* <div
            className="font-size-11 text-muted"
            style={{ textDecoration: "none", color: "gray" }}
          >
            {row.mr_no} | {row.mr_date}
          </div> */}
        </span>
      ),

      // Item: (
      // 	<span className="font-size-12 text-truncate">
      // 		<b>{row.product.name}</b>
      // 	</span>
      // ),
      Item: (
        <div style={{ maxWidth: "200px", wordWrap: "break-word" }}>
          <span className="font-size-12">
            <b>
              {row.product.name}-{row.mr_no}
            </b>
          </span>
        </div>
      ),

      qty: (
        <span>
          {row.qty} {row.unit.name}
        </span>
      ),
      // orderlocation: (
      // 	<span className="font-size-12 text-truncate">
      // 		<b>{row?.orderlocation?.name || "—"}</b>
      // 		{row?.orderlocation?.image && (
      // 			<Button
      // 				color="info"
      // 				size="sm"
      // 				style={{ whiteSpace: "nowrap", marginLeft: 8 }}
      // 				onClick={() => {
      // 					this.setState({
      // 						showImageModal: true,
      // 						selectedOrderLocation:
      // 							row?.orderlocation || null,
      // 					});
      // 				}}>
      // 				View
      // 			</Button>
      // 		)}
      // 	</span>
      // ),
      orderlocation: (
        <span className="font-size-12">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span>
              <b>{row?.orderlocation?.name || "—"}</b>
            </span>
            {
              <Button
                color="info"
                size="sm"
                style={{
                  whiteSpace: "nowrap",
                  marginLeft: 8,
                }}
                disabled={(() => {
                  const loc = row?.orderlocation;
                  if (!loc) return true;
                  if (loc.send_flag1 && loc.image) return false;
                  if (loc.send_flag2 && loc.image2) return false;
                  if (loc.send_flag3 && loc.image3) return false;
                  return true;
                })()}
                onClick={() => {
                  this.setState({
                    showImageModal: true,
                    selectedOrderLocation: row?.orderlocation || null,
                  });
                }}
              >
                View
              </Button>
            }
          </div>
        </span>
      ),

      Action: (
        <Fragment>
          <Link to="#" onClick={() => this.removeListItem(row)}>
            <i
              className="mdi mdi-delete  font-size-18"
              title="Delete"
              style={{ color: "#ff0000" }}
            ></i>
          </Link>
        </Fragment>
      ),
    }));
    const Itemsdatatable = {
      columns: [
        {
          label: "PI No",
          field: "PINo",
          sort: "disabled",
          width: 100,
        },
        // {
        // 	label: "Items List",
        // 	field: "Item",
        // 	sort: "disabled",
        // 	width: 200,
        // },
        {
          label: "Items List",
          field: "Item",
          sort: "disabled",
          width: 200,
          attributes: {
            style: {
              maxWidth: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
          },
        },

        {
          label: "Quantity",
          field: "qty",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Order Location",
          field: "orderlocation",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Action",
          field: "Action",
          sort: "disabled",
          width: 100,
        },
      ],
      rows: selitems,
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <AvForm className="needs-validation">
              <Row>
                <Col
                  md={this.state.showImageModal ? 4 : 6}
                  className="p-1 W-100"
                >
                  <Card className="p-0 ">
                    <CardHeader className="bg-transparent border-bottom ">
                      <Link
                        to="/rfqdashboard"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                      <h5 className="card-title-18 pt-2 d-inline-block">
                        Request for Quotation
                      </h5>
                    </CardHeader>
                    <CardBody className="p-2 ">
                      <div style={{ height: "600px" }}>
                        <Row>
                          <Col md={12}>
                            <div className="float-left">
                              <FormGroup className="m-0 pb-0">
                                <InputGroup>
                                  <Input
                                    type="text"
                                    name="search"
                                    className="form-control d-inline-block"
                                    placeholder="Search"
                                    validate={{
                                      required: true,
                                    }}
                                    onChange={(e) =>
                                      this.props.SetParams({
                                        ...this.props.params,
                                        search: e.target.value,
                                        page: 1,
                                      })
                                    }
                                    onKeyDown={(e) => this.handleSearch(e)}
                                  />
                                  <InputGroupAddon addonType="append">
                                    <Button
                                      color="light"
                                      type="submit"
                                      onClick={() =>
                                        this.props.getPurchaseIndentItems({
                                          ...this.props.params,
                                          page: 1,
                                        })
                                      }
                                    >
                                      <i className="ri-search-line"></i>
                                    </Button>
                                  </InputGroupAddon>
                                </InputGroup>
                              </FormGroup>
                            </div>

                            <div className="float-right">
                              <Dropdown
                                isOpen={this.state.isSocialPf}
                                toggle={() =>
                                  this.setState({
                                    isSocialPf: !this.state.isSocialPf,
                                  })
                                }
                                className="d-lg-inline-block"
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-light mr-2"
                                >
                                  <i className="mdi mdi-filter mr-1"></i>{" "}
                                  Filters
                                </DropdownToggle>

                                <DropdownMenu
                                  className="dropdown-menu-lg"
                                  right
                                >
                                  <div className="px-lg-2">
                                    <AvForm
                                      onValidSubmit={(e, values) =>
                                        this.applyDateFilter(values)
                                      }
                                      onReset={this.clearDateFilter}
                                    >
                                      <Row>
                                        <Col md={6}>
                                          <FormGroup>
                                            <Label htmlFor="validationFromDate">
                                              From Date:
                                            </Label>
                                            <AvField
                                              name="start_date"
                                              type="date"
                                              className="form-control"
                                              id="validationFromDate"
                                              value={this.state.start_date} // controlled value
                                              onChange={(e) =>
                                                this.setState({
                                                  start_date: e.target.value,
                                                })
                                              }
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md={6}>
                                          <FormGroup>
                                            <Label htmlFor="validationToDate">
                                              To Date:
                                            </Label>
                                            <AvField
                                              name="end_date"
                                              type="date"
                                              className="form-control"
                                              id="validationToDate"
                                              value={this.state.end_date} // controlled value
                                              onChange={(e) =>
                                                this.setState({
                                                  end_date: e.target.value,
                                                })
                                              }
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col>
                                          <div className="float-right pt-1">
                                            <Button
                                              type="submit"
                                              color="primary"
                                              className="mr-2"
                                              onClick={() =>
                                                console.log(
                                                  "Submitting filter",
                                                  this.state.start_date,
                                                  this.state.end_date,
                                                )
                                              }
                                            >
                                              Apply
                                            </Button>
                                            <Button
                                              type="reset"
                                              color="secondary"
                                              onClick={
                                                () => this.clearDateFilter() // clears both state and API
                                              }
                                            >
                                              Clear
                                            </Button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </AvForm>
                                  </div>
                                </DropdownMenu>
                              </Dropdown>

                              <ButtonGroup className="waves-effect waves-light d-inline-block ml-2 mr-2">
                                <Button
                                  color="light"
                                  onClick={this.onSortOrderChange}
                                >
                                  {this.props.params.sortOrder === "" && (
                                    <i className="mdi mdi-sort-ascending mr-1"></i>
                                  )}
                                  {this.props.params.sortOrder === "-" && (
                                    <i className="mdi mdi-sort-descending mr-1"></i>
                                  )}
                                </Button>
                                <Button
                                  color="light"
                                  onClick={this.onSortChange}
                                >
                                  {
                                    this.props.SortPIVar[
                                      this.props.params.picurrentSort
                                    ]
                                  }
                                </Button>
                              </ButtonGroup>

                              <Button
                                type="button"
                                color="success"
                                className="waves-effect waves-light mr-2"
                                onClick={() => this.requestingItems()}
                              >
                                <i className="mdi mdi-cart-outline mr-2"></i>
                                Add to List
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12} className="m-2">
                            <div
                              className="table-responsive table-bordered m-0"
                              style={{
                                maxHeight: "470px",
                                overflowY: "auto",
                              }}
                            >
                              <Table className="mb-0 p-0 table-centered">
                                <thead className="bg-light text-center">
                                  <tr>
                                    <th
                                      style={{
                                        width: "20px",
                                      }}
                                    >
                                      <CustomInput
                                        type="checkbox"
                                        name="itemCheckbox"
                                        id="PIlistItem"
                                        checked={this.props.allItemsCheked}
                                        onChange={(e) => {
                                          this.getAllCheckedRequest(e);
                                        }}
                                      />
                                    </th>
                                    <th className="nowrap">PI No</th>
                                    <th className="nowrap">Item</th>
                                    <th className="nowrap">Request Date</th>
                                    <th className="nowrap">Department</th>
                                    <th className="nowrap">Order Location</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.props.PIlistItems.length !== 0 ? (
                                    <>
                                      {this.props.PIlistItems.map(
                                        (item, key) => (
                                          <tr key={item.id}>
                                            <td className="nowrap text-center">
                                              <CustomInput
                                                type="checkbox"
                                                name="pIlistItem"
                                                id={"Piitemscheck" + key}
                                                checked={item.itemcheck}
                                                onChange={(e) => {
                                                  this.getCheckedRequest(
                                                    e,
                                                    item,
                                                    key,
                                                  );
                                                }}
                                              />
                                            </td>
                                            <td className="nowrap text-center">
                                              <Link
                                                to="#"
                                                onClick={() => {
                                                  this.props.PIDetailsModel_open(
                                                    item.purchaseindent_id,
                                                  );
                                                }}
                                                className="text-primary mr-1"
                                              >
                                                {item.purchaseindentcode}
                                              </Link>
                                              <div className="font-size-13 text-primary">
                                                <span>{item.mr_no}</span> |{" "}
                                                <span>{item.mr_date}</span>
                                              </div>
                                            </td>
                                            <td className="nowrap">
                                              <div>
                                                <h5 className="font-size-14 text-primary ">
                                                  <Link
                                                    to="#"
                                                    className="text-primary"
                                                    onClick={() => {
                                                      this.PIItemModel(item);
                                                    }}
                                                  >
                                                    {/* <i className="mdi  mdi-eye text-primary"></i>{" "} */}
                                                    <u>{item.product.name}</u>
                                                  </Link>
                                                  <Link
                                                    to="#"
                                                    onClick={() => {
                                                      this.itemCancle_static(
                                                        item,
                                                      );
                                                    }}
                                                    className="ml-2 text-danger"
                                                  >
                                                    <i className="ri-delete-bin-2-line"></i>
                                                  </Link>
                                                </h5>
                                                <p className="mb-0">
                                                  <span className="text-dark">
                                                    Quantity :{" "}
                                                  </span>

                                                  <span className="font-weight-medium">
                                                    {item.qty}
                                                  </span>
                                                  <span className="font-weight-medium">
                                                    {" "}
                                                    {item.unit.name}
                                                  </span>
                                                </p>
                                                <p className="mb-0">
                                                  Make :{" "}
                                                  <span className="font-weight-medium">
                                                    {item.make}
                                                  </span>
                                                </p>

                                                <p className="mb-0">
                                                  Description :{" "}
                                                  <span className="font-weight-medium">
                                                    {item.description}
                                                  </span>
                                                </p>
                                                <p className="mb-0">
                                                  <Link
                                                    to="#"
                                                    onClick={() =>
                                                      this.props.getMRItemImges(
                                                        item.id,
                                                      )
                                                    }
                                                    className="text-primary"
                                                  >
                                                    <u className=" text-primary">
                                                      View Images
                                                    </u>
                                                  </Link>
                                                </p>
                                              </div>
                                            </td>

                                            <td className="nowrap text-center">
                                              {item.date}
                                            </td>
                                            <td className="nowrap text-center">
                                              {item.product.department.name}
                                            </td>
                                            <td className="text-center">
                                              {item?.orderlocation?.name}

                                              <Button
                                                color="info"
                                                size="sm"
                                                style={{
                                                  whiteSpace: "nowrap",
                                                  marginLeft: 8,
                                                }}
                                                disabled={(() => {
                                                  const loc =
                                                    item?.orderlocation;
                                                  if (!loc) return true;
                                                  if (
                                                    loc.send_flag1 &&
                                                    loc.image
                                                  )
                                                    return false;
                                                  if (
                                                    loc.send_flag2 &&
                                                    loc.image2
                                                  )
                                                    return false;
                                                  if (
                                                    loc.send_flag3 &&
                                                    loc.image3
                                                  )
                                                    return false;
                                                  return true;
                                                })()}
                                                onClick={() => {
                                                  this.setState({
                                                    showImageModal: true,
                                                    selectedOrderLocation:
                                                      item?.orderlocation ||
                                                      null,
                                                  });
                                                }}
                                              >
                                                View
                                              </Button>
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                    </>
                                  ) : (
                                    <tr>
                                      <td colSpan={5}>
                                        <div className="text-center">
                                          <span className="font-size-18 text-danger">
                                            Data not available{" "}
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="float-right p-1">
                              <div className="d-inline-block">
                                <Pagination aria-label="Page navigation example">
                                  <PaginationItem
                                    disabled={this.props.params.page <= 1}
                                  >
                                    <PaginationLink
                                      onClick={(e) => this.openPage(1)}
                                      previous
                                    />
                                  </PaginationItem>

                                  {this.props.params.page > 2 && (
                                    <PaginationItem
                                      disabled={this.props.params.page <= 2}
                                    >
                                      <PaginationLink
                                        onClick={() =>
                                          this.openPage(
                                            this.props.params.page - 2,
                                          )
                                        }
                                      >
                                        {this.props.params.page - 2}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )}
                                  {this.props.params.page > 1 && (
                                    <PaginationItem
                                      disabled={this.props.params.page === 1}
                                    >
                                      <PaginationLink
                                        onClick={() =>
                                          this.openPage(
                                            this.props.params.page - 1,
                                          )
                                        }
                                      >
                                        {this.props.params.page - 1}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )}

                                  <PaginationItem active={true}>
                                    <PaginationLink
                                      onClick={() =>
                                        this.openPage(this.props.params.page)
                                      }
                                    >
                                      {this.props.params.page}
                                    </PaginationLink>
                                  </PaginationItem>
                                  {this.props.params.page + 1 <=
                                    this.props.params.no_of_pages && (
                                    <PaginationItem
                                      disabled={
                                        this.props.params.page + 1 >
                                        this.props.params.no_of_pages
                                      }
                                    >
                                      <PaginationLink
                                        onClick={() =>
                                          this.openPage(
                                            this.props.params.page + 1,
                                          )
                                        }
                                      >
                                        {this.props.params.page + 1}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )}
                                  {this.props.params.page + 2 <=
                                    this.props.params.no_of_pages && (
                                    <PaginationItem
                                      disabled={
                                        this.props.params.page + 2 >
                                        this.props.params.no_of_pages
                                      }
                                    >
                                      <PaginationLink
                                        onClick={() =>
                                          this.openPage(
                                            this.props.params.page + 2,
                                          )
                                        }
                                      >
                                        {this.props.params.page + 2}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )}
                                  {this.props.params.page + 3 <=
                                    this.props.params.no_of_pages &&
                                    this.props.params.page < 3 && (
                                      <PaginationItem
                                        disabled={
                                          this.props.params.page + 3 >
                                          this.props.params.no_of_pages
                                        }
                                      >
                                        <PaginationLink
                                          onClick={() =>
                                            this.openPage(
                                              this.props.params.page + 3,
                                            )
                                          }
                                        >
                                          {this.props.params.page + 3}
                                        </PaginationLink>
                                      </PaginationItem>
                                    )}
                                  {this.props.params.page + 4 <=
                                    this.props.params.no_of_pages &&
                                    this.props.params.page < 2 && (
                                      <PaginationItem
                                        disabled={
                                          this.props.params.page + 4 >
                                          this.props.params.no_of_pages
                                        }
                                      >
                                        <PaginationLink
                                          onClick={() =>
                                            this.openPage(
                                              this.props.params.page + 4,
                                            )
                                          }
                                        >
                                          {this.props.params.page + 4}
                                        </PaginationLink>
                                      </PaginationItem>
                                    )}

                                  <PaginationItem
                                    disabled={
                                      this.props.params.no_of_pages ===
                                      this.props.params.page
                                    }
                                  >
                                    <PaginationLink
                                      onClick={(e) =>
                                        this.openPage(
                                          this.props.params.no_of_pages,
                                        )
                                      }
                                      next
                                    />
                                  </PaginationItem>
                                </Pagination>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col
                  md={this.state.showImageModal ? 3 : 6}
                  className="p-1 W-100"
                >
                  <Card className="p-0">
                    <CardHeader className="bg-transparent border-bottom ">
                      <h5 className="card-title-18 pt-2 d-inline-block">
                        Requesting List
                      </h5>
                    </CardHeader>
                    <CardBody className="pt-0 ">
                      <div style={{ height: "550px" }}>
                        <Row>
                          <Col md={12} className="pt-2">
                            <div className="float-right">
                              <Button
                                type="button"
                                color="success"
                                className="waves-effect waves-light mr-2"
                                onClick={() => {
                                  this.GetVendorslist();
                                }}
                              >
                                <i className="mdi mdi-plus-circle-outline mr-2"></i>
                                Select Vendors
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <MDBDataTableV5
                          hover
                          scrollX={true}
                          maxHeight="350px"
                          responsive
                          striped
                          bordered
                          paging={false}
                          data={Itemsdatatable}
                          searchBottom={false}
                          multipleCheckboxes
                        />
                      </div>

                      <div className="float-right">
                        <Button
                          type="reset"
                          color="light"
                          className="waves-effect waves-light mr-2"
                          href="/rfqdashboard"
                        >
                          Cancel
                        </Button>
                        <Button
                          type="button"
                          color="primary"
                          className="waves-effect waves-light"
                          onClick={() => {
                            this.CreateRequestModel();
                          }}
                        >
                          Create Request
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                {this.state.showImageModal &&
                  (() => {
                    const loc = this.state.selectedOrderLocation;
                    return (
                      (loc?.send_flag1 && loc?.image) ||
                      (loc?.send_flag2 && loc?.image2) ||
                      (loc?.send_flag3 && loc?.image3)
                    );
                  })() && (
                    <Col md={12} xl={3}>
                      <Card className="p-1">
                        <CardHeader>
                          <h5>Order Location Document:</h5>
                          <Button
                            color="secondary"
                            size="sm"
                            className="float-right"
                            onClick={() =>
                              this.setState({ showImageModal: false })
                            }
                          >
                            Close
                          </Button>
                        </CardHeader>
                        <CardBody className="p-0">
                          {(() => {
                            const loc =
                              this.state.selectedOrderLocation;
                            let activeImage = null;
                            if (loc?.send_flag1 && loc?.image)
                              activeImage = loc.image;
                            else if (loc?.send_flag2 && loc?.image2)
                              activeImage = loc.image2;
                            else if (loc?.send_flag3 && loc?.image3)
                              activeImage = loc.image3;

                            if (!activeImage) {
                              return (
                                <p style={{ padding: 10 }}>
                                  No document available
                                </p>
                              );
                            }

                            let cleanUrl = activeImage.trim();
                            try {
                              const parsed = new URL(cleanUrl);
                              cleanUrl =
                                parsed.pathname + parsed.search;
                            } catch (_) {
                              if (!cleanUrl.startsWith("/")) {
                                cleanUrl = "/" + cleanUrl;
                              }
                            }

                            const isPdf = /\.pdf(\?.*)?$/i.test(
                              cleanUrl,
                            );

                            return isPdf ? (
                              <PdfViewer url={cleanUrl} />
                            ) : (
                              <img
                                src={cleanUrl}
                                alt="Order Location"
                                style={{
                                  maxWidth: "100%",
                                  height: "auto",
                                }}
                              />
                            );
                          })()}
                        </CardBody>
                      </Card>
                    </Col>
                  )}
              </Row>
            </AvForm>

            <Modal
              isOpen={this.state.modal_static}
              toggle={this.CreateRequestModel}
              backdrop="static"
              centered
              size="lg"
            >
              <ModalHeader
                toggle={() => {
                  this.RFQModelClose();
                }}
              >
                Summary
              </ModalHeader>
              <ModalBody>
                <Row className="justify-content-center p-0">
                  <Col md={12} className="pt-0">
                    <Nav tabs className="nav-tabs-custom pt-0">
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(1);
                          }}
                          className={classnames(
                            {
                              active: this.state.activeTab === 1,
                            },
                            "pt-3 font-weight-bold card-title-16",
                          )}
                        >
                          Items List |{" "}
                          <span>{this.props.RFQSelectItem.length}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames(
                            {
                              active: this.state.activeTab === 2,
                            },
                            "pt-3 font-weight-bold card-title-16",
                          )}
                          onClick={() => {
                            this.toggleTab(2);
                          }}
                        >
                          Selected Vendors |{" "}
                          <span>{this.props.RFQSelectVendors.length}</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId={1}>
                        <Card>
                          <CardBody>
                            <div className="table-responsive">
                              <Table className="table-centered mb-0 table-nowrap">
                                <thead className="bg-light text-center ">
                                  <tr>
                                    <th> S.No</th>
                                    <th> Item Name</th>
                                    <th> Quantity</th>
                                  </tr>
                                </thead>
                                <tbody className="text-center">
                                  {this.props.RFQSelectItem.map((item, key) => (
                                    <tr key={key}>
                                      <td>{key + 1}</td>
                                      <td>{item.product.name}</td>
                                      <td>
                                        {item.qty} {item.unit.name}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          </CardBody>
                        </Card>

                        <Row>
                          <Col>
                            <div className="float-right mt-2">
                              {this.props.downloadRFQButton === false && (
                                <>
                                  <Button
                                    type="button"
                                    className="btn btn-danger mr-2"
                                    color="light"
                                    onClick={() =>
                                      this.setState({
                                        modal_static: false,
                                      })
                                    }
                                  >
                                    Close
                                  </Button>
                                  <Button
                                    type="submit"
                                    className="btn btn-primary "
                                    color="primary"
                                    onClick={this.handleValidRFQSubmit}
                                  >
                                    Submit Request
                                  </Button>
                                </>
                              )}
                              {this.props.downloadRFQButton === true && (
                                <>
                                  <Link to="/rfqdashboard">
                                    <Button
                                      type="button"
                                      className="btn btn-danger mr-2"
                                      color="light"
                                    >
                                      Close
                                    </Button>
                                  </Link>
                                  <Button
                                    type="submit"
                                    className="btn btn-primary "
                                    color="primary"
                                    onClick={() =>
                                      this.props.generateRFQasPDF(
                                        this.props.rfqID,
                                      )
                                    }
                                  >
                                    Download Request
                                  </Button>
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId={2}>
                        <Card>
                          <CardBody>
                            <div className="table-responsive">
                              <Table className="table-centered mb-0 table-nowrap">
                                <thead className="bg-light text-center ">
                                  <tr>
                                    <th
                                      style={{
                                        width: "20px",
                                      }}
                                    >
                                      S.No
                                      {/* <div className="custom-control custom-checkbox">
                                        <Input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="customercheck"
                                        />
                                        <Label
                                          className="custom-control-label"
                                          htmlFor="customercheck"
                                        >
                                          &nbsp;
                                        </Label>
                                      </div> */}
                                    </th>
                                    <th> Vendors Name</th>
                                    <th> Vendors Locations</th>
                                  </tr>
                                </thead>
                                <tbody className="text-center">
                                  {this.props.RFQSelectVendors.map(
                                    (VendorData, key) => (
                                      <tr key={key}>
                                        <td>
                                          {key + 1}
                                          {/* <div className="custom-control custom-checkbox">
                                            <Input
                                              type="checkbox"
                                              className="custom-control-input"
                                              id={"customercheck" + key}
                                            />
                                            <Label
                                              className="custom-control-label"
                                              htmlFor={"customercheck" + key}
                                            >
                                              &nbsp;
                                            </Label>
                                          </div> */}
                                        </td>
                                        <td>{VendorData.name}</td>
                                        <td>{VendorData.city}</td>
                                      </tr>
                                    ),
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </CardBody>
                        </Card>

                        <Row>
                          <Col>
                            <div className="float-right">
                              <Button
                                type="button"
                                className="btn btn-danger mr-2"
                                color="light"
                                onClick={() => {
                                  this.toggleTab(1);
                                }}
                              >
                                Back
                              </Button>
                              {/* <Button
                                type="submit"
                                className="btn btn-primary"
                                color="primary"
                                disabled={
                                  this.props.downloadRFQButton === true
                                    ? false
                                    : true
                                }
                              >
                                Send Request
                              </Button> */}
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </ModalBody>
            </Modal>
            {/* MODEL FOR PRODUCT VENDER DETAILS */}
            {this.props.addVendorsModel && <AddVendorModel />}
            <ItemDetails
              modelOpen={this.state.PIItemModal_static}
              item={this.state.item_details}
              // ItemLevel="RFQLevel"
              modelClose={() => {
                this.setState({ PIItemModal_static: false });
              }}
            />
            <CancleItemModel
              modelOpen={this.state.modal_Cancel}
              item={this.state.item_details}
              ItemCancelLevel="PIItemCancle"
              modelClose={() => {
                this.setState({ modal_Cancel: false });
              }}
            />
            {this.props.PIMRItemImagesModel && (
              <MRItemImages
                modelOpen={this.props.PIMRItemImagesModel}
                MRIImageData={this.props.PIMRItemImages}
                modelClose={() => {
                  this.props.PIMRItemImagesModel_close();
                }}
              />
            )}

            <GetMRPIDetails />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { userLocation } = state.Mini;
  const {
    PIlistItems,
    PIcheckedItem,
    allItemsCheked,
    params,
    SortPIVar,
    RFQSelectItem,
    vendorslist,
    vendordata,
    allvendorsCheck,
    RFQSelectVendors,
    downloadRFQButton,
    rowlist,
    rfqID,
    loading,
    addVendorsModel,
    PIMRItemImages,
    PIMRItemImagesModel,
  } = state.RequestForQuotation;
  return {
    userLocation,
    PIlistItems,
    PIcheckedItem,
    allItemsCheked,
    params,
    SortPIVar,
    RFQSelectItem,
    vendorslist,
    vendordata,
    allvendorsCheck,
    RFQSelectVendors,
    downloadRFQButton,
    rfqID,
    loading,
    addVendorsModel,
    PIMRItemImages,
    PIMRItemImagesModel,
    //----------
    rowlist,
  };
};

export default connect(mapStatetoProps, {
  getUserLocations,
  getPurchaseIndentItems,
  getPuchaseIndentItemsSuccessful,
  PuchaseIndentItemsChecked,
  SetParams,
  RFQSelectedItems,
  addRFQRequest,
  AllPuchaseIndentItemsChecked,
  generateRFQasPDF,
  tooltipOpen,
  PIDetailsModel_open,
  addVendorsModelOpen,
  getMRItemImges,
  PIMRItemImagesModel_close,

  //--------------------------
})(NewRequestForQuotation);
